import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type BenefitSmileFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const BenefitSmileFilled = forwardRef<SVGSVGElement, BenefitSmileFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(0.5 0.5) scale(0.71875)">
        <path d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM23.7526 18.6745H8.98971V18.6804C8.98971 22.7571 12.2945 26.0618 16.3711 26.0618C20.4478 26.0618 23.7526 22.7571 23.7526 18.6804V18.6745ZM11.4639 9.40205C10.0975 9.40205 8.98967 10.5098 8.98967 11.8763C8.98967 13.2428 10.0975 14.3505 11.4639 14.3505C12.8304 14.3505 13.9382 13.2428 13.9382 11.8763C13.9382 10.5098 12.8304 9.40205 11.4639 9.40205H11.4639ZM21.2783 9.40205C19.9119 9.40205 18.8041 10.5098 18.8041 11.8763C18.8041 13.2428 19.9119 14.3505 21.2783 14.3505C22.6448 14.3505 23.7526 13.2428 23.7526 11.8763C23.7526 10.5098 22.6448 9.40205 21.2783 9.40205Z" />
      </g>
    </svg>
  ),
);

BenefitSmileFilled.displayName = 'BenefitSmileFilled';

export default BenefitSmileFilled;
